/*
 * https://www.drupal.org/docs/8/api/javascript-api/javascript-api-overview
 */

(function ($) {
  'use strict';

  let facetsStatus = null;
  const facetIdAttr = 'data-drupal-facet-id';
  const facetsStatusKey = 'facetsStatus';
  const ariaExpandedAttr = 'aria-expanded';
  const facetCollapseClass = '.facets-collapse';
  const facetsWidgetsClass = '.facets-widget-';

  Drupal.behaviors.facetsBlock = {
    attach: function (context) {
      const facetsStatusInSessionStorage = sessionStorage.getItem(
        facetsStatusKey
      );
      const facetsWidgets$ = $(context).find(facetsWidgetsClass);
      const facetItems$ = $(context).find('.facet-item--expanded');

      // No facets exit
      if (!facetsWidgets$.length || !facetItems$.length) {
        return;
      }

      // Move facet item id to facet widget element
      facetItems$.not('[' + facetIdAttr + ']').each(function(){
        var $id = $(this).children('a').first().data('drupal-facet-item-id');
        if ($id) {
          $(this).attr(facetIdAttr, $id);
        }
      });

      // Set collapsed as default
      facetsWidgets$.addClass('collapse').attr(ariaExpandedAttr, false);

      // Get facets status from Session Storage
      // in order to expand or collapse items
      // if false init facetsStatus as {}
      facetsStatus = JSON.parse(facetsStatusInSessionStorage) || {};

      // Update collapse status from sessionStorage
      for (const prop in facetsStatus) {
        if (facetsStatus.hasOwnProperty(prop)) {
          const val = facetsStatus[prop];
          const classes = val === 'true' ? 'collapse show' : 'collapse';
          $('[' + facetIdAttr + '="' + prop + '"]')
            .find(facetsWidgetsClass)
            .addClass(classes)
            .attr(ariaExpandedAttr, facetsStatus[prop])
            // Update arrow status
            .next(facetCollapseClass)
            .attr(ariaExpandedAttr, facetsStatus[prop]);
        }
      }

      // Foreach facetItem$ append the arrow and manage collapse events
      facetItems$.each(function () {
        if ($(this).find(facetCollapseClass).length) {
          return;
        }

        const facetsWidgets$ = $(this).find(facetsWidgetsClass);

        $(this).append(getArrowElement());
        $(this)
          .find(facetCollapseClass)
          .on('click', function () {
            facetsWidgets$.collapse('toggle');
          });

        updateElementsAfterEvent('shown.bs.collapse', facetsWidgets$, true);
        updateElementsAfterEvent('hidden.bs.collapse', facetsWidgets$, false);
      });
    },
  };

  function updateFacetsStatusForSessionStorage(el) {
    const facetId = $(el)
      .closest('[' + facetIdAttr + ']')
      .attr(facetIdAttr);
    const facetExpanded = $(el).attr(ariaExpandedAttr);
    facetsStatus[facetId] = facetExpanded;
  }

  function setFacetsStatusInSessionStorage() {
    sessionStorage.setItem(facetsStatusKey, JSON.stringify(facetsStatus));
  }

  function setAriaExpandedOnFacetCollapse(el, status) {
    $(el).next(facetCollapseClass).attr(ariaExpandedAttr, status);
  }

  function updateElementsAfterEvent(ev, els, status) {
    els.on(ev, function () {
      setAriaExpandedOnFacetCollapse(this, status);
      $(this).attr(ariaExpandedAttr, status);
      updateFacetsStatusForSessionStorage(this);
      setFacetsStatusInSessionStorage();
    });
  }

  function getArrowElement() {
    return $('<button></button>', {
      class: 'facets-collapse',
      'aria-expanded': 'false',
    });
  }
})(jQuery, Drupal);
